(function () {
  const productCards = document.querySelectorAll(
    ".section-products .product-item"
  );
  if (productCards) {
    productCards.forEach((el) => {
      const productUrl = el.querySelector(".product-info .product-title");
      if (productUrl) {
        const url = productUrl.getAttribute("href");

        const slideImages = el.querySelectorAll(".product-images a");
        if (slideImages) {
          slideImages.forEach((_el) => {
            _el.setAttribute("href", url);
          });
        }
      }
    });
  }

  const productImages = document.querySelectorAll(
    ".product-images .images-list"
  );

  if (productImages) {
    productImages.forEach((images) => {
      const imageSlider = new Splide(images, {
        type: "loop",
        pagination: true,
      }).mount();

      images.addEventListener("mouseenter", () => {
        imageSlider.go(1);
      });
      images.addEventListener("mouseleave", () => {
        imageSlider.go(0);
      });
    });
  }

})();
